import React, { useState } from "react";
import { AdapterPreviewModel } from "../../../../../domain/models/city-adapter-config";
import * as S from "../styles";

type Props = {
  preview: AdapterPreviewModel | null;
  loading: boolean;
  error: string | null;
};

const PreviewPanel: React.FC<Props> = ({ preview, loading, error }) => {
  const [expanded, setExpanded] = useState(false);

  if (loading) {
    return (
      <S.SectionCard>
        <S.SectionTitle>Pré-visualização do Payload</S.SectionTitle>
        <p style={{ color: "#424242", fontSize: 13, fontFamily: "Poppins, sans-serif" }}>Carregando...</p>
      </S.SectionCard>
    );
  }

  if (error || !preview) {
    return (
      <S.SectionCard>
        <S.SectionTitle>Pré-visualização do Payload</S.SectionTitle>
        <S.InfoBox style={{ background: "rgba(255,255,255,0.03)", borderColor: "rgba(255,255,255,0.1)", color: "#424242" }}>
          Sem pré-visualização disponível para este município.
        </S.InfoBox>
      </S.SectionCard>
    );
  }

  return (
    <S.SectionCard>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <S.SectionTitle>Pré-visualização do Payload</S.SectionTitle>
        <S.SmallButton type="button" onClick={() => setExpanded(!expanded)}>
          {expanded ? "▲ Recolher" : "▼ Expandir"}
        </S.SmallButton>
      </div>
      <p style={{ fontSize: 12, color: "#424242", margin: "4px 0 12px", fontFamily: "Poppins, sans-serif" }}>
        Layout: <strong style={{ color: "#fff" }}>{preview.layout}</strong>
      </p>

      {expanded && (
        <S.JsonPreview>{JSON.stringify(preview.payload, null, 2)}</S.JsonPreview>
      )}
    </S.SectionCard>
  );
};

export default PreviewPanel;
